import { render, staticRenderFns } from "./RsaPazienteRiepilogoOperatoriListComponent.vue?vue&type=template&id=a78c1b2a"
import script from "./RsaPazienteRiepilogoOperatoriListComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteRiepilogoOperatoriListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports